module.exports = __webpack_public_path__ + "img/47.53460165.jpg";